import { Component, OnDestroy, OnInit } from '@angular/core'
import { CastService } from '../../../services/cast.service'
import { EventService } from '../../../services/event.service'
import { Subscription } from 'rxjs'
import { RouterService } from '../../../services/router.service'

@Component({
  selector: 'app-cast-dongle',
  standalone: true,
  imports: [],
  templateUrl: './cast-dongle.component.html',
  styleUrls: ['./cast-dongle.component.scss'],
})
export class CastDongleComponent implements OnInit, OnDestroy {
  eventSubscription?: Subscription

  constructor(
    private castService: CastService,
    private eventService: EventService,
    private routerService: RouterService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.registerEventListener()
  }

  ngOnDestroy(): void {
    this.castService.stopCast()
    this.eventSubscription?.unsubscribe()
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((key: string) => {
      switch (key) {
        case 'BACK':
          this.routerService.goBack()
          break
        default:
          break
      }
    })
  }
}
